import { render, staticRenderFns } from "./serviceFeedback.vue?vue&type=template&id=50006b1e&scoped=true"
import script from "./serviceFeedback.vue?vue&type=script&lang=js"
export * from "./serviceFeedback.vue?vue&type=script&lang=js"
import style0 from "./serviceFeedback.vue?vue&type=style&index=0&id=50006b1e&prod&lang=scss&scoped=true"
import style1 from "./serviceFeedback.vue?vue&type=style&index=1&id=50006b1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50006b1e",
  null
  
)

export default component.exports